// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Theme setup
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#f4813f',   // ✅ your custom orange
          secondary: '#f1556a',
          theme: '#FFFFFF',
          light_primary: '#F8B38B'
        },
      },
      dark: {
        colors: {
          primary: '#f4813f',
          secondary: '#f1556a',
          theme: '#000000',
        },
      },
    },
  },
})
